export const AuthConst = {
    EMAIL_FOR_SIGN_IN_STORAGE_KEY: 'emailForSignIn',
    SIGN_IN_PAGE: '/sign-in',
    SIGN_UP_RESULT_PAGE: '/sign-up-result',
    EMAIL_VERIFICATION_PAGE: '/email-verification',
    PHONE_NUMBER_VERIFICATION_PAGE: '/phone-number-verification',
    RESET_PASSWORD_PAGE: '/reset-password'
};